import type { AnyRouter } from "@tanstack/react-router"

// Module-level router handle so compat helpers (redirect()) can navigate
// outside React render.
let router: AnyRouter | null = null

export function setAppRouter(r: AnyRouter) {
  router = r
}

export function getAppRouter() {
  return router
}
